import { useContext } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { AppContext } from "../AppContext";
import {
  mockFallbackMatchesSubmission,
  mockMatchFoundSubmission,
  mockNoMatchesSubmission,
} from "./mockSubmissions";

export function DevResultScreenSwitcher() {
  const { setSubmission, setIsSubmissionCreated, setCurrentStep } = useContext(AppContext);

  const showResult = (submission: typeof mockMatchFoundSubmission) => {
    setSubmission(submission);
    setIsSubmissionCreated(true);
  };

  const backToForm = () => {
    setSubmission(null);
    setIsSubmissionCreated(false);
    setCurrentStep(0);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        right: 16,
        bottom: 16,
        zIndex: 2000,
        bgcolor: "rgba(33, 33, 33, 0.92)",
        color: "#fff",
        borderRadius: 2,
        p: 1.5,
        maxWidth: 220,
        boxShadow: 4,
      }}
    >
      <Typography variant="caption" sx={{ display: "block", mb: 1, opacity: 0.8, fontWeight: 600 }}>
        DEV: Result screens
      </Typography>
      <Stack spacing={0.75}>
        <Button
          size="small"
          variant="contained"
          color="success"
          onClick={() => showResult(mockMatchFoundSubmission)}
          sx={{ flexDirection: "row", textTransform: "none" }}
        >
          Match Found
        </Button>
        <Button
          size="small"
          variant="contained"
          color="warning"
          onClick={() => showResult(mockFallbackMatchesSubmission)}
          sx={{ flexDirection: "row", textTransform: "none" }}
        >
          Fallback
        </Button>
        <Button
          size="small"
          variant="contained"
          color="error"
          onClick={() => showResult(mockNoMatchesSubmission)}
          sx={{ flexDirection: "row", textTransform: "none" }}
        >
          No Matches
        </Button>
        <Button
          size="small"
          variant="outlined"
          sx={{ color: "#fff", borderColor: "#fff", flexDirection: "row", textTransform: "none" }}
          onClick={backToForm}
        >
          Back to form
        </Button>
      </Stack>
    </Box>
  );
}
